// extracted by mini-css-extract-plugin
export default {"title_box":"AdvantagesComponent_title_box__xjXkO","img_box":"AdvantagesComponent_img_box__GQs0n","app":"AdvantagesComponent_app__T+1vd"};